import { Avatar, Box, Card, CardActions, CardContent, Divider, Typography } from '@mui/material';
import { get, sample } from 'lodash';

import { useUserAccount } from '@/api/userAccount';
import { DisplayPreferences } from '@/components/userAccount/DisplayPreferences';

const avatarSrc = sample([
    'https://filedn.com/lTTdn1W2IjNme17D5yWuF74/Ocean-animals-avatars/circleBeluga.png',
    'https://filedn.com/lTTdn1W2IjNme17D5yWuF74/Ocean-animals-avatars/circleMantaRay.png',
    'https://filedn.com/lTTdn1W2IjNme17D5yWuF74/Ocean-animals-avatars/circleManatee.png',
    'https://filedn.com/lTTdn1W2IjNme17D5yWuF74/Ocean-animals-avatars/circleTurtle.png',
    'https://filedn.com/lTTdn1W2IjNme17D5yWuF74/Ocean-animals-avatars/circleWhale.png',
]);

export const AvatarSection = () => {
    const { data: accountData } = useUserAccount();

    return (
        <Card data-testid="user-account-avatar-section">
            <CardContent>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Avatar
                        src={avatarSrc}
                        sx={{
                            height: 120,
                            mb: 2,
                            width: 120,
                            overflow: 'visible',
                            img: {
                                objectFit: 'contain',
                            },
                        }}
                    />
                    <Typography gutterBottom variant="h3">
                        {`${get(accountData, 'data.user.firstName', '')} ${get(accountData, 'data.user.lastName', '')}`}
                    </Typography>
                    <Typography color="text.secondary" variant="body1">
                        {get(accountData, 'data.user.username', '')}
                    </Typography>
                </Box>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: 'flex', flexDirection: 'column' }}>
                <DisplayPreferences />
            </CardActions>
        </Card>
    );
};
